// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"b78c55c0","190":"83a8ba74"}[chunkId] + ".chunk.css";
};